"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useManagedHeight = exports.TopNavClassName = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _context = require("../context");
var _navigation = require("../context/navigation");
var _useIsMobile = require("./useIsMobile");
var _useIsTopAreaNavigationVisible = require("./useIsTopAreaNavigationVisible");
let TopNavClassName = exports.TopNavClassName = /*#__PURE__*/function (TopNavClassName) {
  TopNavClassName["default"] = "top-nav";
  TopNavClassName["mobile"] = "top-nav--is-mobile";
  TopNavClassName["withTopAreaBanner"] = "top-nav--with-top-area-banner";
  TopNavClassName["searchInputVisible"] = "top-nav--search-input-visible";
  TopNavClassName["withTopAreaNavigation"] = "top-nav--with-top-area-navigation";
  return TopNavClassName;
}({});
const getClassList = () => document.body.classList;
const addClassName = className => getClassList().add(className);
const removeClassName = className => getClassList().remove(className);
const useManagedHeight = () => {
  const isMobile = (0, _useIsMobile.useIsMobile)();
  const {
    width
  } = (0, _presentationHooks.useWindowSize)();
  const {
    visible: bannerVisible
  } = (0, _context.useTopAreaBanner)();
  const {
    isVisible: inputVisible
  } = (0, _navigation.useSearchInput)();
  const {
    showSearchOnScroll
  } = (0, _context.useAppConfig)();
  const navigationVisible = (0, _useIsTopAreaNavigationVisible.useIsTopAreaNavigationVisible)();
  (0, _react.useEffect)(() => {
    if (width > 0) {
      addClassName(TopNavClassName.default);
      if (isMobile) {
        addClassName(TopNavClassName.mobile);
        if (showSearchOnScroll && inputVisible) {
          addClassName(TopNavClassName.searchInputVisible);
        } else {
          removeClassName(TopNavClassName.searchInputVisible);
        }
      } else {
        removeClassName(TopNavClassName.mobile);
      }
      if (bannerVisible) {
        addClassName(TopNavClassName.withTopAreaBanner);
      } else {
        removeClassName(TopNavClassName.withTopAreaBanner);
      }
      if (navigationVisible) {
        if (isMobile) {
          removeClassName(TopNavClassName.withTopAreaNavigation);
        } else {
          addClassName(TopNavClassName.withTopAreaNavigation);
        }
      } else {
        removeClassName(TopNavClassName.withTopAreaNavigation);
      }
    }
  }, [isMobile, bannerVisible, width, inputVisible, showSearchOnScroll, navigationVisible]);
};
exports.useManagedHeight = useManagedHeight;